import { render, staticRenderFns } from "./VehicleConfirmation.vue?vue&type=template&id=c5f67306&scoped=true&"
import script from "./VehicleConfirmation.vue?vue&type=script&lang=js&"
export * from "./VehicleConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./VehicleConfirmation.vue?vue&type=style&index=0&id=c5f67306&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f67306",
  null
  
)

export default component.exports